module.exports = __webpack_public_path__ + "static/OGWII_S1-11.2_lazienka_parter_01-400be0d65e137f030405a18b22b1e896.jpg";